<template>
  <div>
    <!-- Tìm kiếm -->
    <b-row>
      <b-col sm="6" class="my-1">
        <b-form-group
          label="Tìm kiếm"
          label-for="filter-input"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filter-input"
              v-model="searchQuery"
              type="search"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button @click="searchQuery = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

      <!-- Chọn số dòng mỗi trang -->
      <b-col sm="6" class="my-1">
        <b-form-group
          label="Số dòng"
          label-for="per-page-select"
          label-cols-sm="6"
          label-cols-md="4"
          label-cols-lg="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-form-select
            id="per-page-select"
            v-model="perPage"
            :options="pageOptions"
            size="sm"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <!-- Hiển thị nút Add -->
      <b-col sm="6" class="my-1 text-right">
        <div>
          <b-button
            v-show="showAdd"
            size="sm"
            class="mr-1"
            @click="$emit('add-tin')"
            variant="outline-primary"
          >Add</b-button>
          <span>Current Page: {{ currentPage }}</span>
        </div>
      </b-col>

      <!-- Phân trang -->
      <b-col sm="6" class="my-1">
        <b-pagination
          align="fill"
          size="sm"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="my-table"
          @input="changePage"
          :disabled="isDisabled"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import fetchClient from "@/fetchClient";
import XuLy from "@/XuLy";
import { debounce } from "lodash";

export default {
  props: {
    crt: String,
    myPerPage: {
      type: [Number, String],
      default: 3,
    },
    showAdd: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      ds: [],
      currentPage: 1,
      rows: 0,
      perPage: 3,
      searchQuery: "",
      pageOptions: [3, 5, 10, 15, { value: 100, text: "Show a lot" }],
      last_page: 0,
      isDisabled:false,      
    };
  },
  mounted() {
    this.perPage = Number(this.myPerPage) || 3;
    this.currentPage = 1;
    this.doGetPage();
  },
  watch: {
    searchQuery: debounce(function () {
      this.currentPage = 1; // reset về trang đầu khi tìm kiếm
      this.doGetPage();
    }, 500),
    perPage() {
      this.currentPage = 1; // reset về trang đầu khi đổi số dòng
      this.doGetPage();
    },
  },
  methods: {
    getPage(page, size, filter) {
      return fetchClient.get(
        `/api/${this.crt}/GetPage?page=${page}&size=${size}&filter=${filter}`
      );
    },
    gotoLastPage(){
      this.currentPage=this.last_page;
    },
    async doGetPage() {
      try {
        this.currentPage = Number(this.currentPage) || 1;
        if (this.currentPage < 1) this.currentPage = 1;

        const res = await this.getPage(
          this.currentPage,
          this.perPage,
          this.searchQuery
        );

        this.ds = res.data.data;
        this.rows = Number(res.data.rowCount || 0);
        this.last_page = Math.ceil(this.rows / this.perPage);
        if (this.last_page < 1) this.last_page = 1;

        if (this.currentPage > this.last_page) {
          this.currentPage = this.last_page;
        }

        this.isDisabled=false;
        this.$emit("send-list", this.ds);
      } catch (err) {
        XuLy.XuLyErr(err);
      }
    },
    changePage(page) {
      this.currentPage = Number(page) || 1;
      this.doGetPage();
    },
  },
};
</script>
